export default __webpack_public_path__ + "7e605dc.png";